import axios from 'axios';
import { bearerTokenKey } from 'src/constants/localStorage';
import { sanitizeProfile } from 'src/utils/api/sanitizeProfile';
import { queryString } from 'src/utils/queryString';
import { widgetViewNames } from 'src/constants/widgets';

import configService from './appConfig';

//todo: we should fix this so it's a config rather than looking at the host for the url 
if (window.location.hostname === 'fav.payorlogic.com') {
  axios.defaults.baseURL = 'https://plapi.payorlogic.com/';
}


axios.interceptors.request.use(
  async config => {
    const token = window.localStorage.getItem(bearerTokenKey);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (window.location.hostname !== 'fav.payorlogic.com') {
//we should not get the base url like this.  just set a default and let TC change it based on env
      const webApiUrl = await configService.getWebApiUrl();
      if (webApiUrl) {
        config.baseURL = webApiUrl;
      }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // intercept the global error
    return response;
  },
  function(error) {
    console.log('error:', error);
    const originalRequest = error.config;
    console.log('originalRequest:', originalRequest);
    if (window.location.pathname !== '/login') {
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        console.log('Retry on 401');
        originalRequest._retry = true;

        return axios.get('/api/v1.0/auth/refresh').then(({ data }) => {
          if (data && data.bearer) {
            window.localStorage.setItem(bearerTokenKey, data.bearer);
            window.localStorage.setItem('tokenExpiration', data.tokenExpiry);

            originalRequest.headers['Authorization'] = `Bearer ${data.bearer}`;
            return axios(originalRequest);
          } else {
            swal({
              title: 'Session Expired',
              text:
                'Your session has expired. Would you like to be redirected to the login page?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: 'Yes',
              closeOnConfirm: false,
            }).then(() => {
              window.location = '/login?ReturnUrl=' + window.location.pathname;
            });
          }
        });
      }
    }
    console.log('Promise.reject');
    return Promise.reject(error);
  }
);

const profilePrefix = 'ARB/profile/';
const mockProfileId = 'mock-profile-id';
const profileKey = `${profilePrefix}${mockProfileId}`;

const appService = {
  /**
   * updates the profile
   * TODO: update with real API
   * @param {object} layout
   * @returns {Promise.resolve(undefined) | Promise.reject(error)}
   */
  async updateProfile(profile) {
    localStorage.setItem(profileKey, JSON.stringify(sanitizeProfile(profile)));
    return Promise.resolve();
  },

  /**
   * updates the profile layout
   * TODO: update with real API
   * @param {object} layout
   * @returns {Promise.resolve(undefined) | Promise.reject(error)}
   */
  async updateProfileLayout(layout) {
    let profile = localStorage.getItem(profileKey);
    if (profile) {
      profile = JSON.parse(profile);
      profile.layouts.forEach((p, i) => {
        if (p.id === layout.id) {
          profile.layouts[i] = layout;
        }
      });
      localStorage.setItem(
        profileKey,
        JSON.stringify(sanitizeProfile(profile))
      );
      return Promise.resolve();
    } else {
      return Promise.reject(new Error('no profile stored'));
    }
  },

  /**
   * creates the profile layout and returns its new id
   * TODO: update with real API
   * @param {object} layout
   * @returns {Promise.resolve(string) | Promise.reject(error)}
   */
  async createProfileLayout(layout) {
    let profile = localStorage.getItem(profileKey);
    if (profile) {
      profile = JSON.parse(profile);
      layout.id = `mock-layout-id-${layout.columns.length}`;
      profile.layouts.push(layout);
      localStorage.setItem(
        profileKey,
        JSON.stringify(sanitizeProfile(profile))
      );
      return Promise.resolve(layout.id);
    } else {
      return Promise.reject(new Error('no profile stored'));
    }
  },

  /**
   * retrieves the list of profiles for this user
   * TODO: update with real API
   *
   * @returns {Promise.resolve(array) | Promise.reject(error)} list of profiles or empty list if none available
   */
  async readProfiles() {
    const profiles = [];
    var profile = localStorage.getItem(profileKey);
    console.log('readProfiles', profile);
    if (profile) {
      profiles.push(JSON.parse(profile));
    }
    return Promise.resolve(profiles);
  },
  setDefaultProfile(widgetViewName) {
    var profile = localStorage.getItem(profileKey);
    var defaultProfile;
    if (!profile) {
      if (widgetViewName === widgetViewNames.rescueNet) {
        defaultProfile =
          '{"id":"mock-profile-id","name":"default","widgets":[{"id":"66e2d53d-fb1c-411a-85cf-05f50daed15a","colSpan":1,"meta":{"type":0}},{"id":"ffed7d2e-64a2-404b-9ecc-2c2368cd9dbb","colSpan":1,"meta":{"type":3}},{"id":"79b5953b-9cca-4368-9fed-69fbb09386b5","colSpan":1,"meta":{"type":4}},{"id":"4c675efc-9d26-4ef5-a5d0-28f4cb8f74b6","colSpan":2,"meta":{"type":6}},{"id":"341055de-2ae7-4c2c-8932-98e012071687","colSpan":1,"meta":{"type":9}},{"id":"7484e0af-b424-4e36-9162-6578c4ea1322","colSpan":1,"meta":{"type":2}}],"layouts":[{"id":"mock-layout-id-4","columns":[{"cells":[{"id":"aac4b082-17ad-4681-8051-c77a58c13bd8","colSpan":1,"type":"normal","meta":{"type":0}},{"id":"168ee432-7f23-47c2-9c01-c61979eafc02","colSpan":1,"type":"normal","meta":{"type":3}}]},{"cells":[{"id":"95c6cbe7-5929-4f8b-8a77-d7da9851ca38","colSpan":2,"type":"normal","meta":{"type":6}}]},{"cells":[{"id":"4e72586f-e1ab-491e-b2ba-06e1bd75f469","colSpan":1,"type":"mirror","meta":{"sourceId":"95c6cbe7-5929-4f8b-8a77-d7da9851ca38"}}]},{"cells":[{"id":"ddb8fa32-6562-42dd-919b-5b9b76703409","colSpan":1,"type":"normal","meta":{"type":4}},{"id":"3a4211fa-42d3-456a-abd2-a036a9234680","colSpan":1,"type":"normal","meta":{"type":9}},{"id":"3dc1ecc3-40bf-4aff-b79c-baa9c5231f84","colSpan":1,"type":"normal","meta":{"type":2}}]}]},{"id":"mock-layout-id-3","columns":[{"cells":[{"id":"aac4b082-17ad-4681-8051-c77a58c13bd8","colSpan":1,"type":"normal","meta":{"type":0}},{"id":"168ee432-7f23-47c2-9c01-c61979eafc02","colSpan":1,"type":"normal","meta":{"type":3}},{"id":"942bd5fa-a6ff-42af-9f4c-b8bb1c20c78e","colSpan":1,"type":"normal","meta":{"type":2}}]},{"cells":[{"id":"95c6cbe7-5929-4f8b-8a77-d7da9851ca38","colSpan":2,"type":"normal","meta":{"type":6}},{"id":"10929211-717a-44f7-82f9-e07e9b12fec0","colSpan":1,"type":"normal","meta":{"type":4}}]},{"cells":[{"id":"4e72586f-e1ab-491e-b2ba-06e1bd75f469","colSpan":1,"type":"mirror","meta":{"sourceId":"95c6cbe7-5929-4f8b-8a77-d7da9851ca38"}},{"id":"aae9b6ba-86af-4e8a-a73f-ef965c40a1a8","colSpan":1,"type":"normal","meta":{"type":9}}]}]}], "expandOptions": [{"id": "A462D0A3-A704-478E-9C31-D4DD880F8479", "name": "Insurance", "expandAll": "true" }, {"id": "CCBC2FEE-58C5-460A-B98F-D27787685F74", "name": "Insurance detail", "expandAll": "true" }, {"id": "C460359B-6B33-42A2-B754-F128B7A8CD22", "name": "Treatment", "expandAll": "true"}, {"id": "AB765AD1-B6EC-4A62-8F11-48C210422A30", "name": "Vital", "expandAll": "true"}]}';
        localStorage.setItem(profileKey, defaultProfile);
      }
      if (widgetViewName === widgetViewNames.rescueNetNoEPCR) {
        defaultProfile =
          '{"id":"mock-profile-id","name":"default","widgets":[{"id":"d9a3e572-9fe7-41ed-a52f-ad761880d9d8","colSpan":1,"meta":{"type":0}},{"id":"506f4392-244a-4c29-8d1e-00e9c2288552","colSpan":1,"meta":{"type":3}},{"id":"b6ca94eb-09fd-4500-8e48-46f16a98b0cd","colSpan":1,"meta":{"type":4}},{"id":"6b93046e-0f24-4082-94f2-db71dd6dd7f4","colSpan":1,"meta":{"type":2}},{"id":"24e3b313-279e-4548-8476-2a2345dc0cfa","colSpan":1,"meta":{"type":9}}],"layouts":[{"id":"mock-layout-id-4","columns":[{"cells":[{"id":"a9c8b335-6aab-4d51-a8ed-ce29a9c42877","colSpan":1,"type":"normal","meta":{"type":0}}]},{"cells":[{"id":"cfd32842-d7eb-47b5-9246-dd24c95819e5","colSpan":1,"type":"normal","meta":{"type":3}}]},{"cells":[{"id":"f7235a06-945e-450c-b8f3-8662a9e5f375","colSpan":1,"type":"normal","meta":{"type":2}},{"id":"1468d46d-f675-4c66-b16d-713cd24bd0d1","colSpan":1,"type":"normal","meta":{"type":9}}]},{"cells":[{"id":"4c3a4dac-bc9f-4075-a9e6-04aa22855d52","colSpan":1,"type":"normal","meta":{"type":4}}]}]},{"id":"mock-layout-id-3","columns":[{"cells":[{"id":"a9c8b335-6aab-4d51-a8ed-ce29a9c42877","colSpan":1,"type":"normal","meta":{"type":0}},{"id":"6a65996b-b3a8-4950-aa71-7aa29443be7b","colSpan":1,"type":"normal","meta":{"type":9}}]},{"cells":[{"id":"cfd32842-d7eb-47b5-9246-dd24c95819e5","colSpan":1,"type":"normal","meta":{"type":3}}]},{"cells":[{"id":"aaf70cd4-7200-46b4-9877-7603897ffcc7","colSpan":1,"type":"normal","meta":{"type":4}},{"id":"f7235a06-945e-450c-b8f3-8662a9e5f375","colSpan":1,"type":"normal","meta":{"type":2}}]}]}], "expandOptions": [{"id": "A462D0A3-A704-478E-9C31-D4DD880F8479", "name": "Insurance", "expandAll": "true" }, {"id": "CCBC2FEE-58C5-460A-B98F-D27787685F74", "name": "Insurance detail", "expandAll": "true" }, {"id": "C460359B-6B33-42A2-B754-F128B7A8CD22", "name": "Treatment", "expandAll": "true"}, {"id": "AB765AD1-B6EC-4A62-8F11-48C210422A30", "name": "Vital", "expandAll": "true"}]}';
        localStorage.setItem(profileKey, defaultProfile);
      }
      if (widgetViewName === widgetViewNames.triTech) {
        defaultProfile =
          '{"id":"mock-profile-id","name":"default","widgets":[{"id":"68868a76-f9a4-4c64-beae-7daf3ea2aee2","colSpan":1,"meta":{"type":0}},{"id":"8c7d444a-1f79-45d8-b598-befa7a1a3a8b","colSpan":1,"meta":{"type":3}},{"id":"d73d75d9-048a-49c4-bc57-d4ac27bda82e","colSpan":1,"meta":{"type":2}}],"layouts":[{"id":"mock-layout-id-4","columns":[{"cells":[{"id":"10991cfc-f776-4b75-a40b-4f5acf6d230c","colSpan":1,"type":"normal","meta":{"type":0}}]},{"cells":[{"id":"acb1c150-7fd1-4f8a-948d-a5891cda3aff","colSpan":1,"type":"normal","meta":{"type":3}}]},{"cells":[{"id":"0a6e917d-d24a-45b4-af3c-2a81bd53c8a7","colSpan":1,"type":"normal","meta":{"type":2}}]},{"cells":[]}]},{"id":"mock-layout-id-3","columns":[{"cells":[{"id":"10991cfc-f776-4b75-a40b-4f5acf6d230c","colSpan":1,"type":"normal","meta":{"type":0}}]},{"cells":[{"id":"0d34dd17-6c0f-4a58-a1c9-0a908dd2fb24","colSpan":1,"type":"normal","meta":{"type":3}}]},{"cells":[{"id":"0a6e917d-d24a-45b4-af3c-2a81bd53c8a7","colSpan":1,"type":"normal","meta":{"type":2}}]}]}],"expandOptions": [{"id": "A462D0A3-A704-478E-9C31-D4DD880F8479", "name": "Insurance", "expandAll": "true"}, {"id": "CCBC2FEE-58C5-460A-B98F-D27787685F74", "name": "Insurance detail", "expandAll": "true" }, {"id": "C460359B-6B33-42A2-B754-F128B7A8CD22", "name": "Treatment", "expandAll": "true"}, {"id": "AB765AD1-B6EC-4A62-8F11-48C210422A30", "name": "Vital", "expandAll": "true"}]}';
        localStorage.setItem(profileKey, defaultProfile);
      }
    }
  },
  /**
   * creates the profile and returns its new id
   * TODO: update with real API
   * @param {object} profile
   * @returns {Promise.resolve(string) | Promise.reject(error)} new id
   */
  async createProfile(profile) {
    localStorage.setItem(
      profileKey,
      JSON.stringify({
        ...sanitizeProfile(profile),
        id: mockProfileId,
      })
    );
    return Promise.resolve(mockProfileId);
  },
  clearProfile() {
    localStorage.removeItem(profileKey);
  },
  async getApplicant(applicantId) {
    const { data } = await axios.get(`/api/v1.0/applicant/${applicantId}`);
    return data;
  },
  getBaseUrl() {
    if (window.location.hostname !== 'fav.payorlogic.com') {
      return window.localStorage.getItem('appConfig.WebApiUrl');
    }
    return axios.defaults.baseURL;
  },
  getToken() {
    var token = window.localStorage.getItem(bearerTokenKey);
    if (token) {
      return `bearer=${token}`;
    }
  },
  async saveApplicant(applicant) {
    const { data } = await axios.put(
      `/api/v1.0/applicant/${applicant.applicantId}`,
      applicant
    );
    return data;
  },
  async rescueNetToPlTripHistory(applicantId) {
    const { data } = await axios.post(
      `/api/v1.0/rescueNetToPlTripHistory?applicantId=${applicantId}`,
      null
    );
    return data;
  },
  async getRescueNetToPlTripHistory(startEpoch, endEpoch) {
    const { data } = await axios.get(
      `/api/v1.0/rescueNetToPlTripHistory?startDateEpoch=${startEpoch}&endDateEpoch=${endEpoch}`
    );
    return data;
  },
  async getRescueNetToPlTripHistoryCsv(startEpoch, endEpoch, isRescueNet) {
    var a = await axios.get(
      `/api/v1.0/rescueNetToPlTripHistory/csvAsBytes?startDateEpoch=${startEpoch}&endDateEpoch=${endEpoch}&isRescueNet=${isRescueNet}`
    );
    return a.data;
  },
  async getApplicantVisits(applicantId) {
    const { data } = await axios.get(
      `/api/v1.0/applicantvisit?applicantId=${applicantId}`
    );
    return data;
  },
  async validateInsurance(applicantId, payorName, subscriberId, npi) {
    var json = {
      payorName: payorName,
      subscriberId: subscriberId,
    };
    var url = `/api/v1.0/applicant/${applicantId}/insuranceValidator`;
    if (npi !== undefined) {
      url = url + `?npiCode=${npi}`;
    }
    const { data } = await axios.post(url, json);
    return data;
  },
  async addALSTrigger(treatment, qualifier, value, callType) {
    var json = {
      treatment: treatment,
      qualifier: qualifier,
      value: value,
      callType: callType,
    };
    const { data } = await axios.post(
      `/api/v1.0/company/RescueNetToPlALSTrigger`,
      json
    );
    return data;
  },
  async getALSTriggers() {
    const { data } = await axios.get(
      `/api/v1.0/company/RescueNetToPlALSTrigger`
    );
    return data;
  },
  async deleteALSTrigger(id) {
    const { data } = await axios.delete(
      `/api/v1.0/company/RescueNetToPlALSTrigger/${id}`
    );
    return data;
  },
  async getALSColors() {
    const { data } = await axios.get(
      `/api/v1.0/company/RescueNetToPlALSColors`
    );
    return data;
  },
  async setALSColors(als1Color, als2Color, sctColor) {
    var json = {
      alS1Color: als1Color,
      alS2Color: als2Color,
      sctColor: sctColor,
    };
    const { data } = await axios.post(
      `/api/v1.0/company/RescueNetToPlALSColors`,
      json
    );
    return data;
  },
  async getCompany() {
    const { data } = await axios.get(`/api/v1.0/company`);
    return data;
  },
  async getCreditEmployment(creditId) {
    const { data } = await axios.get(`/api/v1.0/credit/${creditId}/employment`);
    return data;
  },
  async getCreditTradeAccount(creditId) {
    const { data } = await axios.get(
      `/api/v1.0/credit/${creditId}/tradeAccounts`
    );
    return data;
  },
  async getCreditCollectionAccount(creditId) {
    const { data } = await axios.get(
      `/api/v1.0/credit/${creditId}/collectionAccounts`
    );
    return data;
  },
  async clearDeductibleMonitoringStatus(companyId, status) {
    await axios.post(`/api/v1.0/deductibleManagement/clear/${companyId}?status=${status}`)
  },
  async getDeductibleMonitoringItems(companyId, skip, take, payorName, searchFilter, statusFilter) {
    const { data } = await axios.get(`/api/v1.0/deductibleManagement/${companyId}?skip=${skip}&take=${take}&payorName=${payorName}&searchFilter=${searchFilter}&statusFilter=${statusFilter}`);
    return data;
  },
  async getDeductibleMonitoringPayors(companyId) {
    const { data } = await axios.get(`/api/v1.0/deductibleManagement/payors/${companyId}`);
    return data;
  },
  async getDeductibleMonitoringItemCount(companyId, payorName, searchFilter, statusFilter) {
    const { data } = await axios.get(`/api/v1.0/deductibleManagement/count/${companyId}?payorName=${payorName}&searchFilter=${searchFilter}&statusFilter=${statusFilter}`);
    return data;
  },
  async getDeductibleMonitoringItemStatuses(companyId) {
    const { data } = await axios.get(`/api/v1.0/deductibleManagement/statuses/${companyId}`);
    return data;
  },
  async getDeductibleMonitoringItem(deductibleManagementQueueId, companyId) {
    const { data } = await axios.get(`/api/v1.0/deductibleManagement/${deductibleManagementQueueId}/${companyId}`);
    return data;
  },
  async getCompanyPicker() {
    const { data } = await axios.get(
      `/api/v1.0/deductibleManagement/companyPicker`
    );
    return data;
  },
  async getCompanyClaimsClaritySettings() {
    const { data } = await axios.get(
      `/api/v1.0/claimsClarity/companySettings`
    );
    return data;
  },
  async getCompanyClaimsClaritySettingsForCompany(companyId) {
    const { data } = await axios.get(
      `/api/v1.0/claimsClarity/companySettings/${companyId}`
    );
    return data;
  },
  async getProductDashboardSettings(dashboardId) {
    var url = `/api/v1.0/dashboard/productDashboardSettings`;
    if(dashboardId != null){
      url = url + `?dashboardId=${dashboardId}`
    }
    const { data } = await axios.get(
      url
    );
    return data;
  },
  async getBatchsForDashboardSettings(startDate, endDate, companyIds) {
    var url = `/api/v1.0/dashboard/batchsForDashboardSettings`;
    if(startDate != null && endDate != null){
      url = url + `?startDate=${startDate}&endDate=${endDate}`
    }
    const { data } = await axios.post(
      url,
      companyIds
    );
    return data;
  },
  async getQuickSightDashboardUrl(dashboardId) {
    const { data } = await axios.get(
      `/api/v1.0/QuickSight/Dashboard/${dashboardId}`
    );
    return data;
  },
  async setDMQItemAsReviewed(dmqId, reviewed) {
    const { data } = await axios.put(
      `/api/v1.0/deductibleManagement/reviewCompleted/${dmqId}/reviewed?reviewed=${reviewed}`
    );
    return data;
  },
  async setDMQItemsAsReviewed(dmqIds) {
    await axios.post(
      `/api/v1.0/deductibleManagement/reviewCompleted`,
      dmqIds
    );
  },
  async runSelfPayAnalyzer(applicantId) {
    const { data } = await axios.post(
      `/api/v1.0/applicant/${applicantId}/selfPayTest`
    );
    return data;
  },
  async runDemographics(applicantId) {
    const { data } = await axios.post(
      `/api/v1.0/applicant/${applicantId}/demographicsTest`
    );
    return data;
  },
  async flagDemographicsAsIncorrect(demographicId, incorrectHit) {
    const { data } = await axios.post(
      `/api/v1.0/demographics/${demographicId}/incorrectHit?incorrectHit=${incorrectHit}`
    );
    return data;
  },
  async flagCoverageAsIncorrect(eligibilityId, incorrectHit) {
    const { data } = await axios.post(
      `/api/v1.0/eligibility/${eligibilityId}/incorrectHit?incorrectHit=${incorrectHit}`
    );
    return data;
  },
  async runInsuranceDiscovery(applicantId, npi) {
    var url = `/api/v1.0/applicant/${applicantId}/insuranceDiscovery`;
    if (npi !== undefined) {
      url = url + `?npiCode=${npi}`;
    }
    const { data } = await axios.post(url);
    return data;
  },
  async runUpdateDeductible(applicantId, payor) {
    const { data } = await axios.post(
      `/api/v1.0/applicant/${applicantId}/updateDeductible?payorName=${payor}`
    );
    return data;
  },
  async isPayorNameValid(payorName) {
    const { status } = await axios.get(
      `api/v1.0/companyPayor/valid?payorName=${encodeURIComponent(payorName)}`
    );
    if (status === 200) {
      return true;
    } else {
      return false;
    }
  },
  async getAllPayors() {
    const { data } = await axios.get(`/api/v1.0/payor`);
    return data;
  },
  async getAllPayorValidatorFormatters() {
    const { data } = await axios.get(
      `/api/v1.0/payor/memberIdValidatorFormatter`
    );
    return data;
  },
  async getReleaseNotes() {
    const { data } = await axios.get(
      `/api/v1.0/release/getReleaseNotes`
    );
    return data;
  },
  async addPayorValidatorFormatters(payorId, regEx, prefix, suffix, length) {
    var json = {
      regExFormat: regEx,
      prefix: prefix,
      suffix: suffix,
      length: length,
      payorId: payorId,
    };
    const { status } = await axios.post(
      `/api/v1.0/payor/memberIdValidatorFormatter`,
      json
    );
    if (status === 201 || status === 200) {
      return true;
    } else {
      return false;
    }
  },
  async getAllCompanyPayors() {
    const { data } = await axios.get(`/api/v1.0/companyPayor`);
    return data;
  },
  async updateCompanyPayorMasterPayorId(companyPayorId, payorId) {
    if (companyPayorId && payorId) {
      const { status } = await axios.put(
        `/api/v1.0/companyPayor/${companyPayorId}/payorId/${payorId}`
      );
      return status;
    }
    return -1;
  },
  async getDownPayors(selectedTimeSpan, errorThreshold) {
    var url = `/api/v1.0/payor/statusCheck/down2?minutesChecked=${selectedTimeSpan}&errorThreshold=${errorThreshold}`;
    console.log(url);
    const { data } = await axios.get(url);
    return data;
  },
  async addCompanyPayor(payorId, companyPayorName) {
    var json = {
      companyPayorName: companyPayorName,
      PayorCode: companyPayorName,
      payorId: payorId,
    };
    const { status } = await axios.post(`/api/v1.0/companyPayor`, json);
    if (status === 201) {
      return true;
    } else {
      return false;
    }
  },
  async addUser(username, firstname, lastname) {
    var json = {
      username: username,
      firstName: firstname,
      lastName: lastname,
      roleId: 4,
      addCompanyIdToUsername: true,
    };
    const { data } = await axios.post(`/api/v1.0/user2`, json);
    return data;
  },
  async getCacheKeys() {
    const { data } = await axios.get(`/api.internal/v1.0/cacheKeys`);
    return data;
  },
  async getCacheObject(cachKey) {
    const { data } = await axios.get(
      `/api.internal/v1.0/cacheObject?cacheKey=${cachKey}`
    );
    return data;
  },
  async fullCacheFlush() {
    const { data } = await axios.get(`/api.internal/v1.0/fullCacheFlush`);
    return data;
  },
  async getDemographics(applicantId, include) {
    const { data } = await axios.get(
      `/api/v1.0/demographics?applicantId=${applicantId}&includeApplicantAndGuarantor=${include}`
    );
    return data;
  },
  async getInsuranceFinder(applicantId) {
    const { data } = await axios.get(
      `/api/v1.0/insurancefinder?applicantId=${applicantId}`
    );
    return data;
  },
  async getEligibilityErrorList(applicantId) {
    const { data } = await axios.get(
      `/api/v1.0/eligibilityErrors?applicantId=${applicantId}`
    );
    return data;
  },
  async getBulkSubmissionPendingWork() {
    const { data } = await axios.get(`/plapi/bulkSubmission/pendingWork`);
    return data;
  },
  async getBulkSubmissionRunningLog() {
    const { data } = await axios.get(
      `/plapi/bulkSubmission/queueLog?runningOnly=true`
    );
    return data;
  },
  async getAllBulkSubmissionLog() {
    const { data } = await axios.get(`/plapi/bulkSubmission/queueLog`);
    return data;
  },
  async getBulkSubmissionFailedOrPendingMappingFiles() {
    const { data } = await axios.get(
      `/plapi/bulkSubmission/failedOrPendingMapping`
    );
    return data;
  },
  async getBulkSubmissionMissingBillingStatuses() {
    const { data } = await axios.get(
      `/plapi/bulkSubmission/missingBillingStatus`
    );
    return data;
  },
  async getNonCompleteVendorBatchSubmission() {
    const { data } = await axios.get(
      `/plapi/bulkSubmission/vendorBatchSubmission`
    );
    return data;
  },
  getCredit(applicantId) {
    return new Promise(resolve => {
      axios
        .get(
          `/api/v1.0/credit?applicantId=${applicantId}&includeGuarantor=true`
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async getPayorEligibilities(applicantId) {
    const { data } = await axios.get(
      `/api/v1.0/payorEligibility?applicantId=${applicantId}&returnAllEligibilities=true`
    );

    return data;
  },
  async getPayorEligibility(eligibilityId, applicantId) {
    const { data } = await axios.get(
      `/api/v1.0/getPayorEligibility?eligibilityId=${eligibilityId}&applicantId=${applicantId}`
    );
    return data;
  },
  // GetServiceTypes scopes by the caller's company from the bearer token and declares no
  // applicantId parameter, so the id this used to interpolate was never read (ARB-11131).
  async getServiceTypes() {
    const { data } = await axios.get(`/api/v1.0/getServiceTypes`);
    return data;
  },
  getEligibility271(eligibilityId) {
    return new Promise(resolve => {
      axios
        .get(`/api/v1.0/get271Response?eligibilityId=${eligibilityId}`)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  getScannedCard(scannedCardId) {
    return new Promise(resolve => {
      axios
        .get(`/api/v1.0/scannedCardImage/${scannedCardId}`)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async getValidatedAddress(address1, address2, city, state, zip) {
    if (address1 || city || state || zip) {
      var url = `/api/v1.0/address/validate?address1=${encodeURIComponent(
        address1
      )}
        &address2=${encodeURIComponent(address2)}
        &city=${encodeURIComponent(city)}
        &state=${encodeURIComponent(state)}
        &zip=${encodeURIComponent(zip)}`;
      const { data } = await axios.get(url);
      return data;
    }
  },
  async getDistance(startLat, startLng, endLat, endLng, asCrowFlies) {
    const { data } = await axios.get(
      `/api/v1.0/maps/distance${queryString({
        startLat,
        startLng,
        endLat,
        endLng,
        asCrowFlies,
      })}`
    );
    return data;
  },
  async getMyPermissionsForRescueNetApplicant(rnCompanyId) {
    const { data } = await axios.get(
      `/api/v1.0/permissions${queryString({ rnCompanyId })}`
    );
    console.log('getMyPermissionsForRescueNetApplicant', data);
    return data;
  },
  async getMyPermissions() {
    const { data } = await axios.get(`/api/v1.0/permissions`);
    console.log('getMyPermissions', data);
    return data;
  },
  async getRescueNetCompanyPermissions() {
    const { data } = await axios.get(`/api/v1.0/permissions/rnCompanies`);
    console.log('getRescueNetCompanyPermissions', data);
    return data;
  },
  getRescueNetPermissionsForUser(userId, rnCompanyId) {
    return new Promise(resolve => {
      axios
        .get(`/api/v1.0/permissions/${userId}?rnCompanyId=${rnCompanyId}`)
        .then(response => {
          console.log('getRescueNetPermissionsForUser', response.data);
          resolve(response.data);
        });
    });
  },
  getPermissionsForUser(userId) {
    return new Promise(resolve => {
      axios.get(`/api/v1.0/permissions/${userId}`).then(response => {
        console.log('getPermissionsForUser', response.data);
        resolve(response.data);
      });
    });
  },
  async getProductPermissions() {
    const { data } = await axios.get(`/api/v1.0/permissions/products`);
    console.log('getProductPermissions', data);
    return data;
  },
  async updateRescueNetPermissions(rnCompanyId, userId, permissions) {
    const { data } = await axios.post(
      `/api/v1.0/permissions/${userId}?rnCompanyId=${rnCompanyId}`,
      permissions
    );
    return data;
  },
  async updatePermissions(userId, permissions) {
    const { data } = await axios.post(
      `/api/v1.0/permissions/${userId}`,
      permissions
    );
    return data;
  },
  async updateRescueNetCompanyPermissions(companies) {
    await axios.post(`/api/v1.0/permissions/rnCompanies`, companies);
  },
  async getAllUsersForCompany() {
    const { data } = await axios.get(`/api/v1.0/user`);
    return data;
  },
  async getEligibilityPdf(eligibilityId) {
    var a = await axios.get(
      `/api/v1.0/eligibility/${eligibilityId}/pdfAsBytes`
    );
    return a.data;
  },
  async getPayorListPdf() {
    var a = await axios.get(`/api/v1.0/companyPayor/pdfAsBytes`);
    return a.data;
  },
  async getPayorListCsv() {
    var a = await axios.get(`/api/v1.0/companyPayor/csvAsBytes`);
    return a.data;
  },
  async getWidgetViews() {
    const { data } = await axios.get(`/plapi/widgetView`);
    return data;
  },
  // TODO: cleanup
  async getWidgetPins(widgetId) {
    const { data } = await axios.get(`/plapi/widgetPin/${widgetId}`);
    return data;
  },
  async deleteWidgetPin(widgetId, sectionId) {
    const { data } = await axios.delete(
      `/plapi/widgetPin/${widgetId}/${sectionId}`
    );
    return data;
  },
  async postWidgetPin(widgetId, sectionId) {
    const { data } = await axios.post(
      `/plapi/widgetPin/${widgetId}/${sectionId}`
    );
    return data;
  },
  async deleteWidgets() {
    const { data } = await axios.delete(`/plapi/widgetView`);
    return data;
  },
  async deleteWidget(widgetViewId, widgetId) {
    const { data } = await axios.delete(
      `/plapi/widgetView/${widgetViewId}/widget/${widgetId}`
    );
    return data;
  },
  async addWidget(widgetViewId, widgetType, x, y, h, w) {
    var json = {
      type: widgetType,
      x: x,
      y: y,
      h: h,
      w: w,
    };
    const { data } = await axios.post(
      `/plapi/widgetView/${widgetViewId}/widget`,
      json
    );
    return data;
  },
  async convertHexTiffToPng(hex) {
    var json = {
      tiff: hex,
    };
    const { data } = await axios.post(`/api/v1.0/convert/tiff`, json);
    return data;
  },
  async simulateUser(username) {
    const { data } = await axios.get(
      `/api/v1.0/auth/simulationToken?username=${username}`
    );
    return data;
  },
  login(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1.0/auth', credentials)
        .then(response => {
          resolve(response.data);
        })
        .catch(response => {
          reject(response.status);
        });
    });
  },
  async logout(returnAddress) {    
    //portalUrl is created and stored in QuickLogin.vue
    //Re-route to home logout to remove session info
    let portalUrl = window.localStorage.getItem('portalUrl');
    localStorage.clear();
    if(portalUrl != null){
      window.location = `${portalUrl}/Home/Logout`
    }else{
      window.location = returnAddress;
    }
  },
  async getListOfCompanyPayorsWithScreenScrapeEnabled() {
    const { data } = await axios.get(`/api/v1.0/screenScrapeHealth/list`);
    return data;
  },
  async testScreenScrapeForCompanyPayor(companyPayorId) {
    const { data } = await axios.get(
      `/api/v1.0/screenScrapeHealth/${companyPayorId}`
    );
    return data;
  },

  async getCompanyIdsByTagIds(tagIds){
    try {
      const { data } = await axios.get(`/api/v1.0/list/?tagIds=${tagIds}`);
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getUsernameFromJwt(tokenKey = 'bearerToken') {
    try {
      const token = localStorage.getItem(tokenKey);
  
      if (!token) {
        console.log(`No token found in localStorage with key "${tokenKey}".`);
        return null;
      }
  
      // JWTs are typically structured as header.payload.signature
      // We need the payload (the middle part)
      const base64UrlPayload = token.split('.')[1];
  
      if (!base64UrlPayload) {
        console.error('Invalid JWT format: Could not extract payload.');
        return null;
      }
  
      // Convert Base64Url to Base64 (replace '-' with '+', '_' with '/')
      const base64Payload = base64UrlPayload.replace(/-/g, '+').replace(/_/g, '/');
  
      // Decode Base64 and handle potential UTF-8 characters
      // Solution from MDN: https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
      const jsonPayload = decodeURIComponent(atob(base64Payload).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
  
      const payload = JSON.parse(jsonPayload);
  
      const username = payload.username;
  
      if (typeof username === 'string' && username.length > 0) {
        return username;
      } else {
        console.warn('JWT payload decoded, but "username" claim was missing or empty.');
        return null;
      }
  
    } catch (error) {
      console.error('Error decoding JWT or accessing localStorage:', error);
      return null;
    }
  },
  getCurrentDateTimeString() {
    const now = new Date();
  
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  },
  async log(message, exception, level = 'Debug') {
    var json = {
      UserName: 'BP31',
      TimeStamp: this.getCurrentDateTimeString(),
      LoggerName: 'PL_VUE30',
      Level: level,
      Message: message,
      Exception: exception,
    };
    const { data } = await axios.post(
      `/api/v1.0/log`,
      json
    );
    return data;
  },
};

export default appService;
